/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type EnumUserDisplayStatus = "active" | "pending" | "suspended" | "%future added value";
export type sagaWatchersUser_ArrayIdQueryVariables = {
    ids: Array<string>;
};
export type sagaWatchersUser_ArrayIdQueryResponse = {
    readonly userByIds: ReadonlyArray<{
        readonly name: string | null;
        readonly firstname: string | null;
        readonly lastname: string | null;
        readonly oid_avatar: string | null;
        readonly displayPhone: string | null;
        readonly displayStatus: EnumUserDisplayStatus | null;
        readonly active: number | null;
        readonly deleted: number | null;
        readonly oid_groups: ReadonlyArray<string | null> | null;
        readonly roles: ReadonlyArray<string | null> | null;
        readonly salesforceData: {
            readonly provisioning: ReadonlyArray<string | null> | null;
        } | null;
    } | null> | null;
};
export type sagaWatchersUser_ArrayIdQuery = {
    readonly response: sagaWatchersUser_ArrayIdQueryResponse;
    readonly variables: sagaWatchersUser_ArrayIdQueryVariables;
};



/*
query sagaWatchersUser_ArrayIdQuery(
  $ids: [MongoID!]!
) {
  userByIds(_ids: $ids) {
    name
    firstname
    lastname
    oid_avatar
    displayPhone
    displayStatus
    active
    deleted
    oid_groups
    roles
    salesforceData {
      provisioning
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "_ids",
    "variableName": "ids"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstname",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastname",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_avatar",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayPhone",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayStatus",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deleted",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_groups",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roles",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "UserSalesforceData",
  "kind": "LinkedField",
  "name": "salesforceData",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provisioning",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sagaWatchersUser_ArrayIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "userByIds",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sagaWatchersUser_ArrayIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "userByIds",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "db7fc2b1d50ac993737d04176b3240fa",
    "id": null,
    "metadata": {},
    "name": "sagaWatchersUser_ArrayIdQuery",
    "operationKind": "query",
    "text": "query sagaWatchersUser_ArrayIdQuery(\n  $ids: [MongoID!]!\n) {\n  userByIds(_ids: $ids) {\n    name\n    firstname\n    lastname\n    oid_avatar\n    displayPhone\n    displayStatus\n    active\n    deleted\n    oid_groups\n    roles\n    salesforceData {\n      provisioning\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c2b69be028b23ecb025e54ee337659a6';
export default node;
